import React from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    CardHeader,
    FormGroup,
    Button
} from "reactstrap";


const DeviceSaleSubmitDateRange = ({ valueDateRange, setValueDateRange, handleSubmit }) => {


    return (
        <Col lg='12' md="12" sm="12" >
            <Card>
                <CardHeader>
                    <CardTitle tag="h4">Sale Date Range</CardTitle>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <DateRangePicker
                            rangeDivider={` : `}
                            className={`form-sale-input-date`}
                            value={valueDateRange}
                            onChange={setValueDateRange}
                            format={`y-MM-dd`} />
                    </FormGroup>
                    <div className='submit-button-row'>
                        <Button className="btn-fill" color="primary" type="submit" onClick={() => handleSubmit()}>
                            Submit
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}

export default DeviceSaleSubmitDateRange;